(function() {
  // 只有 29s 模板使用三列布局
  const useThreePerRow =
    document.currentScript?.dataset.variantLayout === 'three-per-row';

  const initialDataEl = document.getElementById(
    'product-variants-data'
  );

  if (!initialDataEl) return;

  let initialProduct;

  try {
    initialProduct = JSON.parse(initialDataEl.textContent);

    if (!Array.isArray(initialProduct.variants)) return;

    // 只有一个变体：隐藏选择器，不接管其他交互
    if (initialProduct.variants.length === 1) {
      const singleVariantStyle = document.createElement('style');

      singleVariantStyle.textContent = `
        .variant-picker__form {
          display:none !important;
        }
      `;

      document.head.appendChild(singleVariantStyle);
      return;
    }

    // 超过六个变体：保留系统原生样式和交互
    if (initialProduct.variants.length > 6) return;
  } catch (error) {
    console.warn('[variant-image-picker] 产品数据读取失败:', error);
    return;
  }

  // 2–6 个变体隐藏原生选项，保留自定义卡片
  const earlyHideStyle = document.createElement('style');

  earlyHideStyle.textContent = `
    .variant-picker__form > :not(#merged-variant-selector):not(script):not(style) {
      display:none !important;
    }

    .variant-picker__form fieldset:not(#merged-variant-selector) {
      display:none !important;
    }
  `;

  document.head.appendChild(earlyHideStyle);

  let selectedMergedVariantId = null;
  let isProcessing = false;
  let cachedMergedFieldset = null;
  let modalEl = null;

  let mediaGallerySyncToken = 0;
  let mediaGallerySyncTimer = null;
  let mediaGalleryAbortController = null;

  function formatVariantPrice(cents) {
    if (typeof cents !== 'number') return '';

    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function' &&
      window.Shopify.money_format
    ) {
      try {
        return window.Shopify.formatMoney(
          cents,
          window.Shopify.money_format
        );
      } catch (e) {}
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function getVariantImageSrc(variant) {
    return (
      variant.featured_image?.src ||
      variant.featured_media?.preview_image?.src ||
      ''
    );
  }

  function hidePickupInfo(root) {
    root = root || document;

    const selector =
      '.pickup-availability-preview, .pickup-availability, [class*="pickup"]';

    const elements = [];

    if (root instanceof Element && root.matches(selector)) {
      elements.push(root);
    }

    if (root.querySelectorAll) {
      elements.push(...root.querySelectorAll(selector));
    }

    elements.forEach(function(el) {
      if (
        el.style.display !== 'none' &&
        el.textContent.includes('Pickup currently not available')
      ) {
        el.style.display = 'none';
      }
    });
  }

  function initializePickupHiding() {
    hidePickupInfo(document);

    const pickupRoot =
      document.querySelector('.variant-picker__form')
        ?.closest('.shopify-section') ||
      document.querySelector('main');

    if (!pickupRoot) return;

    const pendingRoots = new Set();
    let scheduled = false;

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'characterData') {
          if (mutation.target.parentElement) {
            pendingRoots.add(mutation.target.parentElement);
          }
        } else {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              pendingRoots.add(node);
            } else if (
              node.nodeType === 3 &&
              node.parentElement
            ) {
              pendingRoots.add(node.parentElement);
            }
          });
        }
      });

      if (scheduled || pendingRoots.size === 0) return;
      scheduled = true;

      requestAnimationFrame(function() {
        scheduled = false;

        pendingRoots.forEach(function(root) {
          if (root.isConnected) hidePickupInfo(root);
        });

        pendingRoots.clear();
      });
    });

    observer.observe(pickupRoot, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function lockProductInfoHeight(variantPickerForm) {
    const container =
      variantPickerForm.closest('.shopify-section') ||
      variantPickerForm.closest('product-info') ||
      variantPickerForm.parentElement;

    if (!container) return function() {};

    const height = container.getBoundingClientRect().height;

    if (height > 0) {
      container.style.minHeight = height + 'px';
    }

    let released = false;

    return function() {
      if (released) return;
      released = true;

      requestAnimationFrame(function() {
        container.style.minHeight = '';
      });
    };
  }

  function updateAddToCartState(variant) {
    document.querySelectorAll(
      '[name="add"], .product-form__submit, [data-add-to-cart]'
    ).forEach(function(btn) {
      btn.disabled = !variant.available;

      const textEl = btn.querySelector(
        '.add-to-cart-text__content > span:first-child'
      );

      if (textEl && textEl.children.length === 0) {
        textEl.textContent = variant.available
          ? textEl.dataset.addLabel || textEl.textContent
          : textEl.dataset.soldOutLabel || textEl.textContent;
      }
    });
  }

  function updateInventoryDisplay(variant) {
    document.querySelectorAll('.product-inventory__text')
      .forEach(function(el) {
        if (!variant.available) {
          el.textContent = 'Sold out';
        } else if (
          typeof variant.inventory_quantity === 'number' &&
          variant.inventory_quantity > 0 &&
          variant.inventory_quantity <= 10
        ) {
          el.textContent = `Low stock: ${variant.inventory_quantity} left`;
        } else {
          el.textContent = 'In stock';
        }
      });
  }

  function updatePriceDisplay(variant) {
    const formattedPrice = formatVariantPrice(variant.price);
    if (!formattedPrice) return;

    const hasComparePrice =
      typeof variant.compare_at_price === 'number' &&
      variant.compare_at_price > variant.price;

    const formattedComparePrice = hasComparePrice
      ? formatVariantPrice(variant.compare_at_price)
      : null;

    document.querySelectorAll('[ref="priceContainer"], .price')
      .forEach(function(container) {
        const regularBlock = container.querySelector('.price__regular');
        const saleBlock = container.querySelector('.price__sale');

        if (!regularBlock && !saleBlock) return;

        if (hasComparePrice) {
          if (saleBlock) {
            saleBlock.classList.remove('price__hidden');

            const saleEl = saleBlock.querySelector(
              '.price-item--sale.price, .price-item--sale'
            );

            if (saleEl) {
              saleEl.textContent = formattedPrice;
            }

            const compareEl = saleBlock.querySelector('.compare-at-price');

            if (compareEl && formattedComparePrice) {
              compareEl.textContent = formattedComparePrice;
            }
          }

          if (regularBlock) {
            regularBlock.classList.add('price__hidden');
          }
        } else {
          if (regularBlock) {
            regularBlock.classList.remove('price__hidden');

            const regularEl = regularBlock.querySelector('.price');

            if (regularEl) {
              regularEl.textContent = formattedPrice;
            }
          }

          if (saleBlock) {
            saleBlock.classList.add('price__hidden');
          }
        }
      });
  }

  function selectVariant(variant, product, variantPickerForm) {
    if (
      String(selectedMergedVariantId) === String(variant.id)
    ) {
      closeMoreOptionsModal();
      return;
    }

    selectedMergedVariantId = variant.id;

    const releaseHeightLock = lockProductInfoHeight(
      variantPickerForm
    );
    setTimeout(releaseHeightLock, 700);

    const optionKeys = ['option1', 'option2', 'option3'];
    const productOptionNames = product.options || [];

    const nativeInputs = Array.from(
      variantPickerForm.querySelectorAll('input[data-option-name]')
    );

    optionKeys.forEach(function(key, i) {
      const optionValue = variant[key];
      const optionName = productOptionNames[i];

      if (!optionValue || !optionName) return;

      const radio = nativeInputs.find(function(input) {
        return (
          input.dataset.optionName === optionName &&
          input.value === optionValue
        );
      });

      if (radio && !radio.checked) {
        radio.checked = true;
      }
    });

    const variantIdInput = document.querySelector('input[name="id"]');

    if (variantIdInput) {
      variantIdInput.value = variant.id;
    }

    updateAddToCartState(variant);
    updateInventoryDisplay(variant);
    updatePriceDisplay(variant);

    const imgSrc = getVariantImageSrc(variant);

    if (imgSrc) {
      const mainImage = document.querySelector(
        '.product__media-item img, .product__image img, .product-media img'
      );

      if (mainImage) {
        mainImage.src = imgSrc;
        mainImage.srcset = imgSrc;
      }
    }

    syncMediaGallery(variant.id);

    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    document.querySelectorAll('.variant-image-picker__card')
      .forEach(function(card) {
        const isThisOne =
          String(card.dataset.variantId) === String(variant.id);

        card.classList.toggle('is-selected', isThisOne);

        card.style.setProperty(
          'border-color',
          isThisOne ? '#000000' : '#e5e0d6',
          'important'
        );
      });

    closeMoreOptionsModal();
  }

  function syncMediaGallery(variantId) {
    const requestToken = ++mediaGallerySyncToken;

    clearTimeout(mediaGallerySyncTimer);

    if (mediaGalleryAbortController) {
      mediaGalleryAbortController.abort();
      mediaGalleryAbortController = null;
    }

    mediaGallerySyncTimer = setTimeout(function() {
      mediaGallerySyncTimer = null;
      performMediaGallerySync(variantId, requestToken);
    }, 120);
  }

  async function performMediaGallerySync(variantId, requestToken) {
    if (requestToken !== mediaGallerySyncToken) return;

    const mediaGalleryEl = document.querySelector('media-gallery');
    if (!mediaGalleryEl) return;

    const sectionEl = mediaGalleryEl.closest('.shopify-section');
    if (!sectionEl || !sectionEl.id) return;

    const sectionId = sectionEl.id.replace('shopify-section-', '');
    const controller = new AbortController();
    mediaGalleryAbortController = controller;

    const url = new URL(
      window.location.pathname,
      window.location.origin
    );

    url.search = window.location.search;
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url.toString(), {
        signal: controller.signal
      });

      if (
        !response.ok ||
        requestToken !== mediaGallerySyncToken
      ) {
        return;
      }

      const html = await response.text();

      if (
        controller.signal.aborted ||
        requestToken !== mediaGallerySyncToken
      ) {
        return;
      }

      await new Promise(function(resolve) {
        requestAnimationFrame(function() {
          setTimeout(resolve, 0);
        });
      });

      if (
        controller.signal.aborted ||
        requestToken !== mediaGallerySyncToken
      ) {
        return;
      }

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGallery = doc.querySelector('media-gallery');
      const currentGallery = document.querySelector('media-gallery');

      if (!newGallery || !currentGallery) return;

      const wrapper = currentGallery.parentElement;
      const height = currentGallery.getBoundingClientRect().height;

      if (wrapper && height > 0) {
        wrapper.style.minHeight = height + 'px';
      }

      currentGallery.replaceWith(newGallery);

      if (wrapper) {
        const waitForImages = Promise.all(
          Array.from(newGallery.querySelectorAll('img'))
            .map(function(img) {
              if (img.complete) return Promise.resolve();

              return new Promise(function(resolve) {
                img.addEventListener('load', resolve, { once: true });
                img.addEventListener('error', resolve, { once: true });
              });
            })
        );

        Promise.race([
          waitForImages,
          new Promise(function(resolve) {
            setTimeout(resolve, 800);
          })
        ]).then(function() {
          requestAnimationFrame(function() {
            if (newGallery.isConnected) {
              wrapper.style.minHeight = '';
            }
          });
        });
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.warn('[variant-image-picker] 图库同步失败:', error);
      }
    } finally {
      if (mediaGalleryAbortController === controller) {
        mediaGalleryAbortController = null;
      }
    }
  }

  function buildVariantCard(
    variant,
    product,
    variantPickerForm,
    options
  ) {
    options = options || {};

    const isAvailable = variant.available;
    const isInitiallySelected =
      String(selectedMergedVariantId) === String(variant.id);

    const card = document.createElement('label');
    card.className = 'variant-image-picker__card';
    card.dataset.variantId = variant.id;

    if (isInitiallySelected) {
      card.classList.add('is-selected');
    }

    card.style.cssText = `
      position:relative !important;
      display:flex !important;
      flex-direction:row !important;
      align-items:center !important;
      gap:12px !important;
      width:100% !important;
      min-width:0 !important;
      max-width:100% !important;
      margin:0 !important;
      padding:4px 10px 4px 4px !important;
      background:#ffffff !important;
      border:2px solid ${isInitiallySelected ? '#000000' : '#e5e0d6'} !important;
      border-radius:10px !important;
      cursor:${isAvailable ? 'pointer' : 'not-allowed'} !important;
      opacity:${isAvailable ? '1' : '0.55'} !important;
      box-sizing:border-box !important;
      text-align:left !important;
    `;

    const input = document.createElement('input');
    input.type = 'radio';
    input.name = options.inputName || 'merged-variant';
    input.value = variant.id;
    input.disabled = !isAvailable;

    input.style.cssText = `
      position:absolute !important;
      opacity:0 !important;
      width:1px !important;
      height:1px !important;
      pointer-events:none !important;
    `;
    card.appendChild(input);

    const mediaWrap = document.createElement('div');
    mediaWrap.style.cssText = `
      position:relative !important;
      flex:0 0 72px !important;
      width:72px !important;
      height:72px !important;
      overflow:hidden !important;
      border-radius:8px !important;
      background:#f5f3ef !important;
      box-sizing:border-box !important;
    `;
    card.appendChild(mediaWrap);

    const imgSrc = getVariantImageSrc(variant);

    if (imgSrc) {
      const img = document.createElement('img');
      img.loading = 'lazy';

      const imageUrl = new URL(imgSrc, window.location.origin);
      imageUrl.searchParams.set('width', '400');

      img.src = imageUrl.toString();
      img.alt = variant.title;

      img.style.cssText = `
        width:100% !important;
        height:100% !important;
        object-fit:cover !important;
        display:block !important;
        ${!isAvailable ? 'filter:grayscale(100%) !important;' : ''}
      `;
      mediaWrap.appendChild(img);
    }

    const textWrap = document.createElement('div');
    textWrap.style.cssText = `
      display:flex !important;
      flex-direction:column !important;
      justify-content:center !important;
      flex:1 1 0 !important;
      min-width:0 !important;
      min-height:72px !important;
      gap:6px !important;
      padding:0 !important;
      box-sizing:border-box !important;
    `;

    // 29s 不显示 MOST POPULAR，其他模板保持原样
    if (options.showHotBadge && !useThreePerRow) {
      const hotBadge = document.createElement('span');
      hotBadge.textContent = 'MOST POPULAR';

      hotBadge.style.cssText = `
        display:inline-block !important;
        align-self:flex-start !important;
        background:#e53935 !important;
        color:#ffffff !important;
        font-size:8px !important;
        font-weight:600 !important;
        line-height:1.2 !important;
        padding:3px 5px !important;
        border-radius:10px !important;
        white-space:nowrap !important;
      `;
      textWrap.appendChild(hotBadge);
    }

    if (!isAvailable) {
      const soldOutLabel = document.createElement('span');
      soldOutLabel.textContent = 'Sold Out';

      soldOutLabel.style.cssText = `
        display:inline-block !important;
        align-self:flex-start !important;
        background:#ff4444 !important;
        color:#ffffff !important;
        font-size:10px !important;
        font-weight:bold !important;
        padding:2px 6px !important;
        border-radius:3px !important;
      `;
      textWrap.appendChild(soldOutLabel);
    }

    const nameEl = document.createElement('div');

    nameEl.textContent = [
      variant.option1,
      variant.option2,
      variant.option3
    ].filter(function(opt) {
      return opt && opt !== 'Default Title';
    }).join(' | ') || variant.title;

    nameEl.style.cssText = `
      display:block !important;
      font-size:13px !important;
      font-weight:400 !important;
      letter-spacing:0.02em !important;
      color:#000000 !important;
      line-height:1.3 !important;
      text-transform:none !important;
      margin:0 !important;
      max-height:none !important;
      white-space:normal !important;
      overflow-wrap:anywhere !important;
    `;

    // 仅 29s：固定预留两行，超过两行截断
    if (useThreePerRow) {
      nameEl.style.setProperty('display', '-webkit-box', 'important');
      nameEl.style.setProperty('-webkit-line-clamp', '2', 'important');
      nameEl.style.setProperty(
        '-webkit-box-orient',
        'vertical',
        'important'
      );
      nameEl.style.setProperty('height', '33.8px', 'important');
      nameEl.style.setProperty('min-height', '33.8px', 'important');
      nameEl.style.setProperty('max-height', '33.8px', 'important');
      nameEl.style.setProperty('overflow', 'hidden', 'important');
    }

    textWrap.appendChild(nameEl);

    const priceEl = document.createElement('div');
    priceEl.style.cssText = `
      display:flex !important;
      align-items:baseline !important;
      flex-wrap:wrap !important;
      gap:4px 8px !important;
      min-width:0 !important;
      font-size:14px !important;
      font-weight:400 !important;
      color:#333333 !important;
    `;

    const currentPriceEl = document.createElement('span');

    currentPriceEl.textContent = formatVariantPrice(variant.price)
      .replace(/\.00(?=\D|$)/g, '');

    currentPriceEl.style.cssText = `
      color:#333333 !important;
      font-weight:400 !important;
      white-space:nowrap !important;
    `;
    priceEl.appendChild(currentPriceEl);

    const compareAtPrice = Number(variant.compare_at_price);

    if (
      Number.isFinite(compareAtPrice) &&
      compareAtPrice > Number(variant.price)
    ) {
      const compareSavingsWrap = document.createElement('span');
      compareSavingsWrap.style.cssText = `
        display:inline-flex !important;
        align-items:baseline !important;
        flex-wrap:wrap !important;
        gap:4px 8px !important;
        min-width:0 !important;
        max-width:100% !important;
      `;

      const comparePriceEl = document.createElement('s');

      comparePriceEl.textContent = formatVariantPrice(compareAtPrice)
        .replace(/\.00(?=\D|$)/g, '');

      comparePriceEl.style.cssText = `
        font-size:12px !important;
        font-weight:400 !important;
        color:#888888 !important;
        text-decoration:line-through !important;
        white-space:nowrap !important;
      `;
      compareSavingsWrap.appendChild(comparePriceEl);

      const savingsEl = document.createElement('span');

      savingsEl.textContent = `Save $${Math.round(
        (compareAtPrice - Number(variant.price)) / 100
      )}`;

      savingsEl.style.cssText = `
        font-size:13px !important;
        font-weight:400 !important;
        color:#008000 !important;
        line-height:1.3 !important;
        white-space:nowrap !important;
      `;
      compareSavingsWrap.appendChild(savingsEl);
      priceEl.appendChild(compareSavingsWrap);
    }

    const inventoryQuantity = variant.inventory_quantity;

    if (
      typeof inventoryQuantity === 'number' &&
      Number.isFinite(inventoryQuantity)
    ) {
      const inventoryEl = document.createElement('span');

      // 保留之前指定的公式，不是实际剩余库存
      const displayQuantity = Math.max(
        2,
        Math.floor(inventoryQuantity * 0.1 - 1)
      );

      inventoryEl.textContent = `${displayQuantity} Left`;

      inventoryEl.style.cssText = `
        display:inline-block !important;
        margin-left:auto !important;
        text-align:right !important;
        font-size:13px !important;
        font-weight:400 !important;
        color:#e53935 !important;
        line-height:1.3 !important;
        white-space:nowrap !important;
      `;
      priceEl.appendChild(inventoryEl);
    }

    textWrap.appendChild(priceEl);
    card.appendChild(textWrap);

    // 仅 29s：图片在上、文字在下
    if (useThreePerRow) {
      card.style.setProperty('flex-direction', 'column', 'important');
      card.style.setProperty('align-items', 'stretch', 'important');
      card.style.setProperty('gap', '0', 'important');
      card.style.setProperty('padding', '4px', 'important');

      mediaWrap.style.setProperty('flex', '0 0 auto', 'important');
      mediaWrap.style.setProperty('width', '100%', 'important');
      mediaWrap.style.setProperty('height', 'auto', 'important');
      mediaWrap.style.setProperty('aspect-ratio', '1 / 1', 'important');

      textWrap.style.setProperty('flex', '1 1 auto', 'important');
      textWrap.style.setProperty('min-height', '0', 'important');
      textWrap.style.setProperty('padding', '8px 2px 4px', 'important');
    }

    if (isAvailable) {
      card.addEventListener('pointerdown', function(e) {
        if (e.pointerType !== 'touch') e.preventDefault();
      });

      card.addEventListener('click', function(e) {
        e.preventDefault();
        input.checked = true;

        const currentForm =
          card.closest('.variant-picker__form') ||
          document.querySelector('.variant-picker__form') ||
          variantPickerForm;

        selectVariant(variant, product, currentForm);
      });
    }

    return card;
  }

  function openMoreOptionsModal(product, variantPickerForm) {
    if (modalEl) {
      modalEl.style.display = 'flex';
      return;
    }

    modalEl = document.createElement('div');
    modalEl.id = 'variant-image-picker-modal';

    modalEl.style.cssText = `
      position:fixed !important;
      inset:0 !important;
      background:rgba(0,0,0,0.5) !important;
      z-index:9999 !important;
      display:flex !important;
      align-items:flex-end !important;
      justify-content:center !important;
    `;

    const panel = document.createElement('div');
    panel.style.cssText = `
      background:#ffffff !important;
      width:100% !important;
      max-width:640px !important;
      max-height:85vh !important;
      overflow-y:auto !important;
      border-radius:16px 16px 0 0 !important;
      box-sizing:border-box !important;
      padding:16px !important;
      position:relative !important;
    `;

    const header = document.createElement('div');
    header.style.cssText = `
      display:flex !important;
      align-items:center !important;
      justify-content:space-between !important;
      margin-bottom:12px !important;
    `;

    const title = document.createElement('div');
    title.textContent = 'All Options';

    title.style.cssText = `
      font-size:16px !important;
      font-weight:700 !important;
      color:#222 !important;
    `;

    const closeBtn = document.createElement('span');
    closeBtn.textContent = '\u00D7';

    closeBtn.style.cssText = `
      font-size:24px !important;
      line-height:1 !important;
      cursor:pointer !important;
      color:#888 !important;
      padding:0 6px !important;
    `;
    closeBtn.addEventListener('click', closeMoreOptionsModal);

    header.appendChild(title);
    header.appendChild(closeBtn);
    panel.appendChild(header);

    const list = document.createElement('div');
    list.style.cssText = `
      display:flex !important;
      flex-direction:column !important;
      gap:10px !important;
      width:100% !important;
      min-width:0 !important;
    `;

    product.variants.forEach(function(variant) {
      list.appendChild(
        buildVariantCard(
          variant,
          product,
          variantPickerForm,
          { inputName: 'merged-variant-modal' }
        )
      );
    });

    panel.appendChild(list);
    modalEl.appendChild(panel);

    modalEl.addEventListener('click', function(e) {
      if (e.target === modalEl) closeMoreOptionsModal();
    });

    document.body.appendChild(modalEl);
  }

  function closeMoreOptionsModal() {
    if (modalEl) modalEl.style.display = 'none';
  }

  function addVariantImages() {
    if (isProcessing) return;
    isProcessing = true;

    requestAnimationFrame(function() {
      try {
        const productScript = document.getElementById(
          'product-variants-data'
        );
        if (!productScript) return;

        const product = JSON.parse(productScript.textContent);

        if (
          !Array.isArray(product.variants) ||
          product.variants.length < 2 ||
          product.variants.length > 6
        ) {
          return;
        }

        const variantPickerForm = document.querySelector(
          '.variant-picker__form'
        );
        if (!variantPickerForm) return;

        variantPickerForm.querySelectorAll('fieldset')
          .forEach(function(fieldset) {
            if (fieldset.id !== 'merged-variant-selector') {
              fieldset.style.cssText = `
                position:absolute !important;
                left:-9999px !important;
                opacity:0 !important;
                pointer-events:none !important;
              `;
            }
          });

        let mergedFieldset = document.getElementById(
          'merged-variant-selector'
        );

        if (
          !mergedFieldset &&
          cachedMergedFieldset &&
          cachedMergedFieldset.children.length > 0
        ) {
          variantPickerForm.insertBefore(
            cachedMergedFieldset,
            variantPickerForm.firstChild
          );
          return;
        }

        if (!mergedFieldset) {
          mergedFieldset = document.createElement('div');
          mergedFieldset.id = 'merged-variant-selector';
          cachedMergedFieldset = mergedFieldset;

          variantPickerForm.insertBefore(
            mergedFieldset,
            variantPickerForm.firstChild
          );

          setTimeout(function() {
            variantPickerForm.querySelectorAll(
              'fieldset:not(#merged-variant-selector)'
            ).forEach(function(fieldset) {
              const firstRadio = fieldset.querySelector(
                'input[type="radio"]'
              );

              if (
                firstRadio &&
                !fieldset.querySelector('input[type="radio"]:checked')
              ) {
                firstRadio.checked = true;
                firstRadio.dispatchEvent(
                  new Event('change', { bubbles: true })
                );
              }
            });
          }, 200);
        }

        if (mergedFieldset.children.length > 0) return;

        mergedFieldset.style.cssText = `
          display:flex !important;
          flex-direction:column !important;
          width:100% !important;
          min-width:0 !important;
          max-width:100% !important;
          box-sizing:border-box !important;
        `;

        const headerRow = document.createElement('div');
        headerRow.style.cssText = `
          display:flex !important;
          align-items:center !important;
          justify-content:space-between !important;
          margin-bottom:10px !important;
        `;

        const headerTitle = document.createElement('div');
        headerTitle.textContent = 'SELECT AN OPTION ';

        headerTitle.style.cssText = `
          font-size:16px !important;
          font-weight:600 !important;
          color:#222222 !important;
          text-transform:uppercase !important;
        `;

        const headerCount = document.createElement('span');
        headerCount.textContent = `(${product.variants.length})`;

        headerCount.style.cssText = `
          color:#000000 !important;
          font-weight:400 !important;
        `;

        headerTitle.appendChild(headerCount);
        headerRow.appendChild(headerTitle);
        mergedFieldset.appendChild(headerRow);

        const list = document.createElement('div');
        list.id = 'variant-image-picker-track';

        list.style.cssText = useThreePerRow
          ? `
            display:grid !important;
            grid-template-columns:repeat(3, minmax(0, 1fr)) !important;
            gap:10px !important;
            width:100% !important;
            min-width:0 !important;
            max-width:100% !important;
            box-sizing:border-box !important;
          `
          : `
            display:flex !important;
            flex-direction:column !important;
            gap:10px !important;
            width:100% !important;
            min-width:0 !important;
            max-width:100% !important;
            box-sizing:border-box !important;
          `;

        const fragment = document.createDocumentFragment();

        product.variants.forEach(function(variant, index) {
          fragment.appendChild(
            buildVariantCard(
              variant,
              product,
              variantPickerForm,
              { showHotBadge: index === 1 }
            )
          );
        });

        list.appendChild(fragment);
        mergedFieldset.appendChild(list);

        setTimeout(function() {
          const firstAvailableInput = list.querySelector(
            'input[type="radio"]:not(:disabled)'
          );

          if (firstAvailableInput) {
            const variantId = parseInt(firstAvailableInput.value, 10);

            const variant = product.variants.find(function(v) {
              return v.id === variantId;
            });

            if (variant) {
              firstAvailableInput.checked = true;

              const currentForm =
                list.closest('.variant-picker__form') ||
                document.querySelector('.variant-picker__form') ||
                variantPickerForm;

              selectVariant(variant, product, currentForm);
            }
          }
        }, 300);
      } catch (error) {
        console.warn('[variant-image-picker] 卡片初始化失败:', error);
      } finally {
        isProcessing = false;
      }
    });
  }

  let repairScheduled = false;

  function scheduleRepairCheck() {
    if (repairScheduled) return;
    repairScheduled = true;

    requestAnimationFrame(function() {
      repairScheduled = false;
      if (isProcessing) return;

      const form = document.querySelector('.variant-picker__form');
      if (!form) return;

      const existing = document.getElementById(
        'merged-variant-selector'
      );

      if (!existing || existing.children.length === 0) {
        addVariantImages();
      }
    });
  }

  function initialize() {
    initializePickupHiding();
    addVariantImages();

    new MutationObserver(function(mutations) {
      const removedOurNode = mutations.some(function(mutation) {
        return Array.from(mutation.removedNodes).some(function(node) {
          return (
            node.nodeType === 1 &&
            (
              node.id === 'merged-variant-selector' ||
              (
                node.querySelector &&
                node.querySelector('#merged-variant-selector')
              )
            )
          );
        });
      });

      if (removedOurNode) scheduleRepairCheck();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('change', function(e) {
    if (e.target.name && e.target.name.startsWith('option')) {
      setTimeout(addVariantImages, 100);
    }
  });

  document.addEventListener('submit', function(e) {
    if (!selectedMergedVariantId) return;

    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || !form.action.includes('/cart/add')) return;

    const idInput = form.querySelector('input[name="id"]');

    if (idInput) {
      idInput.value = selectedMergedVariantId;
    }
  }, true);

  document.addEventListener('click', function(e) {
    if (!selectedMergedVariantId) return;
    if (!(e.target instanceof Element)) return;

    const addButton = e.target.closest(
      '[name="add"], button[type="submit"], .product-form__submit, [data-add-to-cart]'
    );
    if (!addButton) return;

    const form =
      addButton.closest('form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');

    if (idInput && idInput.value != selectedMergedVariantId) {
      idInput.value = selectedMergedVariantId;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }, true);

  const styleTag = document.createElement('style');
  styleTag.textContent = `
    .variant-image-picker__card.is-selected {
      border-color:#000000 !important;
    }
  `;
  document.head.appendChild(styleTag);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {
      once: true
    });
  } else {
    initialize();
  }
})();
